<template>
    <span
      class="status-pill"
      :class="typeClass"
      :style="{'background-color': styleFill, 'color': styleTextColor}"
    >
    <slot name="label">{{ statusLabel }}</slot>
    </span>
</template>

<style scoped>
.status-pill {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.9rem;
  display: inline-block;
  text-transform: capitalize;
  background-color: var(--kate-background);
  color: var(--kate-type-white);
}

.success {
  background-color: var(--kate-success);
  color: var(--kate-type-dark);
}

.warning {
  background-color: var(--kate-warning);
  color: var(--kate-type-dark);
}

.danger {
  background-color: var(--kate-danger);
  color: var(--kate-type-white);
}

.primary {
  background-color: var(--kate-primary);
  color: var(--kate-type-dark);
}

.neutral {
  background-color: var(--kate-button-outlined-hover);
  color: var(--kate-type-dark);
}

.empty {
  background-color: transparent;
  color: var(--kate-type-light);
}
</style>

<script>
export default {
  props: {
    statusValue: {
      type: String,
      default: '',
    },
    fill: {
      type: String,
      default: '',
    },
    textColor: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      validator: value => ['success', 'warning', 'danger', 'primary', 'neutral', 'empty'].includes(value),
    },
  },
  computed: {
    styleFill() {
      return this.fill || null;
    },

    styleTextColor() {
      return this.textColor || null;
    },

    typeClass() {
      return !this.statusValue || this.statusValue === '-' ? 'empty' : (this.type || '');
    },

    statusLabel() {
      return !this.statusValue || this.statusValue === '-' ? '-' : this.statusValue.replace(/[_-]/g, ' ');
    },
  },
};
</script>
